export default __webpack_public_path__ + "static/media/icon-consultation-history.d9cecda2.svg";